export default __webpack_public_path__ + "static/media/netflix-logo.23df4ca3.png";